import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AnnotationImageDetail, AnnotationObjectForUpdate } from '../../_objects/inspection-image-annotation';
import { ApiService } from '../base/api-base.service';
import { AnnotationImageContractService } from '../interfaces/annotation-image-contract.service';
import { NetworkStatusService } from '../network-status.service';
import { AnnotationImageOfflineService } from '../offline/annotation-image-offline.service';
import { AnnotationImageOnlineService } from '../online/annotation-image-online.service';

@Injectable({
  providedIn: 'root'
})
export class AnnotationImageService extends ApiService<AnnotationImageContractService> implements AnnotationImageContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: AnnotationImageOfflineService,
    protected onlineService: AnnotationImageOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  // /api/v1/inspections/{inspectionId}/images/{inspectionImageId}/annotation
  getImageAnnotations(inspectionId: string, inspectionImageId: string): Observable<AnnotationImageDetail> {
    return this.service.getImageAnnotations(inspectionId, inspectionImageId);
  }

  // /api/v1/inspections/{inspectionId}/images/{inspectionImageId}/annotation

  putImageAnnotations(updateAnnotation: AnnotationObjectForUpdate, inspectionId: string, usedImageMode: number)
    : Observable<AnnotationImageDetail> {
    return this.service.putImageAnnotations(updateAnnotation, inspectionId, usedImageMode);
  }

  // /api/v1/inspections/{inspectionId}/images/{inspectionImageId}/annotation/upload

  putModifiedImage(inspectionId: string, inspectionImageId: string, file: File, usedImageMode: number): Observable<AnnotationImageDetail> {
    return this.service.putModifiedImage(inspectionId, inspectionImageId, file, usedImageMode);
  }
}
